export default () => {
	// Removing anchor from the contact form URL
	let form = document.querySelector('#contact_form');
    if (form) {
        let action = form.getAttribute('action');
        if (action.includes('#')) {
            let newAction = action.split('#')[0];
            form.setAttribute('action', newAction);
        }
    }
}